import styles from './Card.module.css'

function Card(props){

    return (
        <div className={styles.card}>
            <p className = {styles.title}>
                {props.name}
            </p>
            <div className = {styles.number}>
                {props.value}
            </div>
        </div>
    )
}

export default Card